import { useEffect, useRef } from 'react';
import axios from 'axios';

export default function useSelectedFileBasePrefetch({ API_BASE, provider = 'github', organization, project, repositoryID, prNumber, getProjectKey, prDetails, selectedFilePath, normalizePath, fileTree, getAllFilePathsFromTree, loadingFileMap, fileCache, ensureFileLoaded }) {
  const postedBasePathsRef = useRef(new Set());
  const prefetchStartedRef = useRef(false);

  useEffect(() => {
    if (provider === 'azure') return;
    const sel = normalizePath(selectedFilePath || '');
    if (!sel) return;
    (async () => {
      try {
        if (!postedBasePathsRef.current.has(sel)) {
          const projectKey = getProjectKey();
          if (projectKey) {
            let base;
            if (provider === 'github') base = `${API_BASE}/api/github/pull-requests/${encodeURIComponent(organization)}/${encodeURIComponent(project)}/${prNumber}`;
            else if (provider === 'gitlab') base = `${API_BASE}/api/gitlab/projects/${encodeURIComponent(organization)}/merge-requests/${prNumber}`;
            else if (provider === 'bitbucket') base = `${API_BASE}/api/bitbucket/pull-requests/${encodeURIComponent(organization)}/${encodeURIComponent(project)}/${prNumber}`;
            else base = `${API_BASE}/api/pull-requests/${encodeURIComponent(organization)}/${encodeURIComponent(project)}/${encodeURIComponent(repositoryID)}/${prNumber}`;
            await axios.post(`${base}/selected-file-base`, { path: sel }, { headers: { 'X-API-KEY': projectKey } });
            postedBasePathsRef.current.add(sel);
          }
        }
      } catch (error) {
        console.error('Failed to post selected file base:', error);
      }
    })();
  }, [API_BASE, organization, project, prNumber, selectedFilePath, getProjectKey, normalizePath]);

  useEffect(() => {
    if (provider === 'azure') return; 
    if (!prDetails || prefetchStartedRef.current) return;
    const files = Array.isArray(prDetails.files) ? prDetails.files : [];
    if (files.length === 0) return;
    const ordered = fileTree ? getAllFilePathsFromTree(fileTree) : files.map(f => normalizePath(f.path || f.filename || '')).filter(Boolean);
    if (ordered.length === 0) return;
    prefetchStartedRef.current = true;
    const selected = normalizePath(selectedFilePath || '');
    const toFetch = ordered.filter(p => p && p !== selected && !loadingFileMap[p] && !(fileCache && fileCache[p]));
    if (toFetch.length === 0) return;
    Promise.allSettled(toFetch.map(p => ensureFileLoaded(p, { trackAbort: true })));
  }, [prDetails, fileTree, selectedFilePath, getAllFilePathsFromTree, normalizePath, loadingFileMap, fileCache, ensureFileLoaded]);

  return { postedBasePathsRef, prefetchStartedRef };
}



